import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  groupContainer: {
    backgroundColor: "#FCFCFD",
    borderRadius: "12px",
    padding: "16px",
    marginTop: "12px",
  },
  groupContainerOnCustomerView: {
    padding: "12px !important",
  },
  groupHeader: {},
  groupName: {
    ...getTextProperties("18px"),
  },
  groupTotalLabel: {
    ...getTextProperties("14px"),
    color: "#308CDB",
  },
  groupTotalValues: {
    marginLeft: "16px",
  },
  groupTotalValue: {
    ...getTextProperties("15px"),
    whiteSpace: "nowrap",
  },
  iconMargin: {
    marginLeft: "12px",
  },
  iconArrow: {
    marginLeft: "24px",
  },
  verticalSeparator: {
    height: "24px",
    backgroundColor: "#D0D5DD",
    width: "1px",
    marginLeft: "17px",
  },
  groupContent: {
    marginTop: "16px",
  },
  button: {
    cursor: "pointer",
  },
  groupNameInput: {
    minWidth: "250px",
  },
  groupNameActions: {},
  groupTotalExpand: {
    marginLeft: "16px",
    flexBasis: "18%",
  },
  groupTotalExpandNotShowed: {
    marginLeft: "0px !important",
    flexBasis: "0 !important",
    width: "min-content",
  },
  groupTotal: {},
  symbolAndTotal: {},
  symbol: {
    marginRight: "16px",
  },
  flex: {
    display: "flex",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexColumnAlignEnd: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
}));

export default styles;

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});
